import React from 'react'
import { Route, Switch } from 'react-router'
import { Router } from 'react-router-dom'

import {
  AuthenticatedPage,
  Home,
  Login,
  CookiePolicy,
  Profile,
  SearchResults,
  FrequentlyAskedQuestions,
  SimilarClauses,
} from '../components/Pages'
import { updateLanguageFromUrl, history } from '../utils/UrlManipulation'
import { AUTH0, GOOGLE } from '../utils/Authentication'

function Routes() {
  updateLanguageFromUrl()
  return (
    <React.Fragment>
      <Router history={history}>
        <Switch>
          <Route exact path="/login" render={() => {
            return <Login providerType={AUTH0} />
          }} />
          <Route exact path="/login/dev" render={() => {
            return <Login providerType={GOOGLE} />
          }} />
          <Route path="/cookies" component={CookiePolicy} />
          <AuthenticatedPage defaultProvider={AUTH0}>
            <Route path="/search" component={SearchResults} />
            <Route path="/similar/:clauseId" component={SimilarClauses} />
            <Route path="/faq" component={FrequentlyAskedQuestions} />
            <Route path="/profile" component={Profile} />
            <Route exact path="/" component={Home} />
          </AuthenticatedPage>
        </Switch>
      </Router>
    </React.Fragment>
  )
}

export default Routes
